import apiClient from './apiClient';

export interface FieldDictionary {
  id: string;
  name: string;
  state: string;
  type: string;
  address: string;
}

class FieldDictionaryService {
  private baseUrl = '/api/FieldDictionary';

  // Получить поля по типу игры
  async getFieldsByType(type: string): Promise<FieldDictionary[]> {
    const response = await apiClient.get<FieldDictionary[]>(`${this.baseUrl}/by-type`, {
      params: { type }
    });
    return response;
  }

  // Получить поля по штату и типу игры
  async getFieldsByStateAndType(state: string, type: string): Promise<FieldDictionary[]> {
    const response = await apiClient.get<FieldDictionary[]>(`${this.baseUrl}/by-state`, {
      params: { state, type }
    });
    return response;
  }

}

export default new FieldDictionaryService(); 